module.exports = __webpack_public_path__ + "img/logo_pracenavysocine.bcb503a.svg";